import { PrimaryColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { mediaQuery } from '@picsart/rc/helpers';

const useStyles = createUseStyles(
  () => ({
    wrapper: {
      width: '100%',
      maxWidth: 634,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s16,
      margin: [112, 'auto'],

      [mediaQuery(480)]: {
        textAlign: 'center',
      },
    },
    icon: {
      width: 64,
      height: 64,
      fill: PrimaryColors.base.default,
    },
    title: {
      fontSize: FontSizes.s24,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l32,
    },
    description: {
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
      textAlign: 'center',
      color: TextColors.tint2,
    },
  }),
  { name: 'no-result' },
);

export default useStyles;
